'use es6';

import { fromJS } from 'immutable';
import { PERCENTILES } from '../constants/metricTypes';
export const injectCombination = (primaryDataset, comboDataset, comboMetric) => {
  const comboBuckets = comboDataset.getIn(['dimension', 'buckets']).reduce((bucketObj, curr) => bucketObj.set(curr.get('key'), curr), fromJS({}));
  return primaryDataset.updateIn(['dimension', 'buckets'], primaryBuckets => primaryBuckets.map(bucket => bucket.setIn(['metrics', comboMetric, PERCENTILES], comboBuckets.getIn([bucket.get('key'), 'metrics', comboMetric, PERCENTILES]))));
};